// components/CursorFollower.tsx
import React, { useEffect, useState, useRef } from 'react';

const CursorFollower: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isMoving, setIsMoving] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
      if (!isVisible) setIsVisible(true);
      setIsMoving(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setIsMoving(false), 200);
    };
    const handleMouseLeave = () => {
      setIsVisible(false);
      setIsMoving(false);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    const handleMouseEnter = () => setIsVisible(true);

    window.addEventListener('mousemove', handleMouseMove);
    document.body.addEventListener('mouseleave', handleMouseLeave);
    document.body.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
      document.body.removeEventListener('mouseenter', handleMouseEnter);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  // Taille du cercle : suffisamment grande pour englober la flèche (environ 32x32)
  const circleSize = 20;
  // On décale le cercle pour que la flèche soit à l'intérieur
  // Le hotspot est en haut à gauche, donc on décale le cercle de 16px vers le haut et la gauche
  const offsetX = circleSize / 2 - [7 , -16][0]; // Décalage horizontal (16px vers la gauche)
  const offsetY = circleSize / 2 - [0, 0][1]; // Décalage vertical (16px vers le haut)

  return (
    <div
      className="hidden md:block fixed top-0 left-0 pointer-events-none z-[9999] transition-transform duration-75 ease-out"
      style={{
        transform: `translate(${position.x - offsetX}px, ${position.y - offsetY}px)`,
      }}
    >
      <div
        className={`
          rounded-full transition-all duration-200 ease-out
          ${isMoving 
            ? 'bg-secondary opacity-80 shadow-lg scale-110' 
            : 'border-2 border-accent bg-transparent'
          }
        `}
        style={{
          width: `${circleSize}px`,
          height: `${circleSize}px`,
          boxShadow: isMoving ? '0 0 12px rgba(22,241,158,0.5)' : 'none',
        }}
      />
    </div>
  );
};

export default CursorFollower;